import React from 'react';
import { NoMatchText, MacroButton } from '../../DecisionTree.styles';
import { connect } from 'react-redux';
import { addEdgeToDecisionTreePath } from 'actions/searchActions';
import isFunction from 'lodash/isFunction';

const DTNoResults = (props) => {
  const onClick = () => {
    // if dispatchProcessingAction is defined, use it, otherwise push to path
    if (isFunction(props.dispatchProcessingAction)) {
      props.dispatchProcessingAction();
    } else {
      props.addEdge(props.path);
    }
  };

  return (
    <>
      <NoMatchText marginTop={'7px'}>{props.topText}</NoMatchText>
      {props.buttonText && (
        <MacroButton active={true} onClick={onClick}>
          {props.buttonText}
        </MacroButton>
      )}
      {props.bottomText && <NoMatchText marginTop={'0px'}>{props.bottomText}</NoMatchText>}
    </>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const actions = {
    addEdge: (path) => dispatch(addEdgeToDecisionTreePath(path)),
  };

  // if passed processingAction prop, then wrap it into dispatch
  if (isFunction(ownProps.processingAction)) {
    actions.dispatchProcessingAction = () => dispatch(ownProps.processingAction());
  }

  return actions;
};

export default connect(null, mapDispatchToProps)(DTNoResults);
